import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { useUiStore, type UiLanguage } from "@/core/stores/ui.store";
import {
  SUPPORTED_LANGUAGES,
  registerLanguageResolver,
} from "@/core/utils/func/language-resolver";
import en from "@/locales/en.json";
import fr from "@/locales/fr.json";
import zh from "@/locales/zh.json";

const syncDocumentLang = (lng: string) => {
  if (typeof document === "undefined") return;
  const short = (lng || "fr").split("-")[0] || "fr";
  document.documentElement.lang = short;
};

/** Rejoue la langue i18n dans le store UI pour la couche API (Accept-Language). */
const syncUiStoreLanguage = (lng: string) => {
  const short = (lng || "fr").split("-")[0] as UiLanguage;
  if (
    SUPPORTED_LANGUAGES.includes(short) &&
    useUiStore.getState().language !== short
  ) {
    useUiStore.getState().setLanguage(short);
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    detection: {
      lookupQuerystring: "lng",
      order: ["querystring", "localStorage"],
    },
    supportedLngs: SUPPORTED_LANGUAGES,
    keySeparator: false,
    react: {
      useSuspense: true,
    },
    resources: {
      en: { translation: en },
      fr: { translation: fr },
      zh: { translation: zh },
    },
    fallbackLng: "fr",
    saveMissing: true,
    saveMissingTo: "all",
  })
  .then(() => {
    syncDocumentLang(i18n.language);
    syncUiStoreLanguage(i18n.language);
  });

i18n.on("languageChanged", (lng) => {
  syncDocumentLang(lng);
  syncUiStoreLanguage(lng);
});

// Branche la résolution de langue de `core` sur l'instance i18n, sans que
// `core` ait à importer `app` (enregistrement par callback).
registerLanguageResolver(() => i18n.language);

export { getCurrentLanguage } from "@/core/utils/func/language-resolver";

export default i18n;
